module.exports = __webpack_public_path__ + "static/media/customer-interporc.85445b38.png";